import DashboardLayout from "features/LayoutContainers/DashboardLayout";
import DashboardNavbar from "features/Navbars/DashboardNavbar";
import { Formik, Form as FormikForm } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import WithAuthWrapper from "withWrapper/withAuthWrapper";
import {
  getBusinessCard,
  getBusinessCardThunk,
  getDashboardSummaryThunk,
  getLoadingStatus
} from "redux/slices/dashboardSlice";
import LoadingComponent from "components/LoadingComponent";
import { updateExistingBusinessDetails } from "services/api/usersApi";
import BusinessDesign from "./design";

const CardDetailsPage: React.FC = (props) => {
  const formikRef = useRef<any>(null);

  const cardDetails = useSelector(getBusinessCard);

  const accessToken = localStorage.getItem("stmpz-token") || "";
  const businessId = localStorage.getItem("stmpz-business-id") || "";
  const isLoading = useSelector(getLoadingStatus);
  const dispatch = useDispatch();
  const [hasFetchedCard, setHasFetchedCard] = useState(false);

  useEffect(() => {
    if (accessToken && !hasFetchedCard) {
      setHasFetchedCard(true);
      dispatch(getBusinessCardThunk({ accessToken, businessId }));
    }
  }, [accessToken, businessId, dispatch, hasFetchedCard]);

  const onSubmit = async (values) => {
    try {
      const result = await updateExistingBusinessDetails(values, accessToken);
      dispatch(getBusinessCardThunk({ accessToken, businessId }));
      dispatch(
        getDashboardSummaryThunk({ accessToken, businessId: result.id })
      );
      alert("Updated Successfully");
    } catch (error) {
      alert(error);
    }
  };
  const onClick = () => {
    //Trigger formik button as outside the form
    if (formikRef.current) {
      formikRef.current.handleSubmit();
    }
  };
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        {isLoading || !(Object.values(cardDetails).length > 0) ? (
          <LoadingComponent />
        ) : (
          <Formik
            initialValues={cardDetails}
            onSubmit={onSubmit}
            innerRef={formikRef}
          >
            {({ values, errors, handleBlur, handleChange, setFieldValue }) => (
              <FormikForm>
                <BusinessDesign
                  isEdit={true}
                  campaign={values}
                  setFieldValue={setFieldValue}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  onClick={onClick}
                />
              </FormikForm>
            )}
          </Formik>
        )}
      </DashboardLayout>
    </>
  );
};
export default WithAuthWrapper(CardDetailsPage);
